import React, { useState } from "react";
import { loadCss } from "helpers/function";
import appConfig from "config/appConfig";
import axios from "axios";
import { ToastBottomEnd } from "views/components/Toast";
import { toastErrorMessageWithParameterConfig, toastSuccessMessageWithParameterConfig } from "config/toastConfig";

loadCss("/assets/css/pages/login/login-1.css");

const LicencePage = () => {
  const [licenceKey, setLicenceKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onChangeLicenceKey = (e) => {
    setLicenceKey(e.target.value);
    setError("");
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!licenceKey.trim()) {
      setError("Veuillez entrer une clé de licence");
      return;
    }
    setLoading(true);

    try {
      const response = await axios.post(
        `${appConfig.apiDomaine}/api/licence`,
        { key: licenceKey.trim() }
      );

      if (response.data.status === "success") {
        ToastBottomEnd.fire(
          toastSuccessMessageWithParameterConfig("Licence activée avec succès")
        );
        window.location.href = "/dashboard";
      } else {
        const msg = response.data.message || "Erreur d'activation";
        ToastBottomEnd.fire(toastErrorMessageWithParameterConfig(msg));
        setError(msg);
      }
    } catch (error) {
      const msg =
        error.response?.data?.message ||
        "Erreur de connexion au serveur";
      ToastBottomEnd.fire(toastErrorMessageWithParameterConfig(msg));
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="kt-grid kt-grid--ver kt-grid--root kt-page"
      style={{ height: "100vh" }}
    >
      <div
        className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1"
        id="kt_login"
      >
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
          <div
            className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
            style={{
              backgroundImage: `url(/assets/images/satis_default_image.png)`,
              height: "100vh",
            }}
          >
            <div className="kt-grid__item">
              <span className="kt-login__logo">
                <img
                  alt="Logo"
                  src={"/assets/images/satisLogo.png"}
                  width={"200vh"}
                />
                <span
                  style={{
                    color: "white",
                    fontSize: "1em",
                    paddingLeft: "5px",
                  }}
                >
                  SATIS 2020.1
                </span>
              </span>
            </div>
            <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
              <div className="kt-grid__item kt-grid__item--middle">
                <h3 className="kt-login__title">Activation de Licence</h3>
                <h4 className="kt-login__subtitle">
                  Veuillez activer votre licence pour continuer
                </h4>
              </div>
            </div>
            <div className="kt-grid__item">
              <div className="kt-login__info">
                <div className="kt-login__copyright">
                  &copy; SATIS MACRO 2020.1
                </div>
              </div>
            </div>
          </div>

          <div className="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper">
            <div className="kt-login__body">
              <div className="kt-login__form" style={{ paddingTop: "15%" }}>
                <div className="kt-login__title">
                  <div className="form-group row" style={{ marginTop: "11%" }}>
                    <div
                      style={{ textAlign: "center" }}
                      className="col-lg-12 col-xl-12"
                    >
                      <img
                        src={"/assets/images/satisLogo.png"}
                        alt="logo"
                        style={{
                          maxWidth: "100px",
                          maxHeight: "100px",
                          textAlign: "center",
                        }}
                      />
                    </div>
                  </div>
                  <h3>Activation de Licence</h3>
                </div>

                {error ? (
                  <div className="alert alert-danger alert-bold" role="alert">
                    <div className="alert-text text-center">{error}</div>
                  </div>
                ) : null}

                <form className="kt-form" id="kt_licence_form">
                  <div className="form-group row">
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Clé de licence"
                      name="licence_key"
                      value={licenceKey}
                      onChange={onChangeLicenceKey}
                      autoFocus
                    />
                  </div>

                  <div className="kt-login__actions">
                    {!loading ? (
                      <button
                        type="submit"
                        id="kt_licence_activate_submit"
                        className="btn btn-primary btn-elevate kt-login__btn-primary"
                        onClick={onSubmit}
                      >
                        Activer
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary kt-spinner kt-spinner--left kt-spinner--md kt-spinner--light"
                        type="button"
                        disabled
                      >
                        Activation...
                      </button>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicencePage;
